import TraditionalRafflePrizePanel from './traditionalRafflePrizePanel.container'

export default TraditionalRafflePrizePanel